import $ from 'jquery';
import throttle from 'cmnjs/function/throttle';
import debounce from 'cmnjs/function/debounce';

// "Slider-globals"
const slides = [-1];
const Slider = function () {
  this.el = false;
  this.items = false;
  this.sizes = [];
  this.max = 0;
  this.current = 0;
  this.interval = false;
  this.coord = false;
  this.opts = {
    speed: 500,
    dots: false,
    arrows: null,
    hiddenSlide: false,
    xDown: null,
    yDown: null,
  };

  this.init = function (el, opts) {
    this.el = el;
    this.ul = el.children('ul');
    this.max = el.outerWidth();
    this.items = this.ul.children('li').each(this.calculate.bind(this));
    this.opts = $.extend(this.opts, opts);

    slides[this.el.data('slider-number')] = 0;
    this.setup();

    return this;
  };
};

Slider.fn = Slider.prototype;

Slider.fn.setup = function () {
  this.ul.css({ width: `${this.items.length * 100}%`, position: 'relative' });
  this.items.css('width', `${100 / this.items.length}%`);

  if (this.opts.dots && this.items.length > 1) {
    this.dotsInit(this.opts.dots);
  }

  // this.calculatecoord();

  $(window).on('resize', debounce(this.resize, 500).bind(this));

  // $(window).on('scroll', throttle(this.scrollCalculate.bind(this), 50)).triggerHandler('scroll');

  if (this.opts.arrows.length) {
    this.opts.arrows
      .find('span')
      .first()
      .hide()
      .end()
      .click(e => {
        // this[$(e.target).parents('span').data('direction')]();
        this[$(e.currentTarget).data('direction')]();
      });
    if (this.items.length <= 1) {
      this.opts.arrows
        .find('span')
        .last()
        .hide();
    }
  }

  this.el.on('touchstart', this.handleTouchStart.bind(this));
  this.el.on('touchmove', throttle(this.handleTouchMove.bind(this), 100));
};

Slider.fn.handleTouchStart = function (evt) {
  this.xDown = evt.originalEvent.touches[0].clientX;
  this.yDown = evt.originalEvent.touches[0].clientY;
};

Slider.fn.handleTouchMove = function (evt) {
  if (!this.xDown || !this.yDown) {
    return;
  }

  const xUp = evt.originalEvent.touches[0].clientX;
  const yUp = evt.originalEvent.touches[0].clientY;

  const xDiff = this.xDown - xUp;
  const yDiff = this.yDown - yUp;

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    if (xDiff > 0) {
      this.next();
    } else {
      this.prev();
    }
  }

  this.xDown = null;
  this.yDown = null;
};

Slider.fn.resize = function () {
  this.ul.children('li').each(this.calculate.bind(this));

  const width = `${Math.min(Math.round((this.el.outerWidth() / this.el.parent().outerWidth()) * 100), 100)}%`;

  this.el.css('width', width);
  this.calculatecoord();
};

Slider.fn.dotsInit = function (el) {
  let html = '';

  $.each(this.items, index => {
    // omijamy krope dla slidera z ukrytym slajdem
    const hideShowDot = (this.opts.hiddenSlide && index === 0) ? ' hidden' : ' ';

    html += `
      <li class="slider__dot${hideShowDot}${index < 1 ? ' active' : ''}">
          <svg role="img" title="dot">
              <use xlink:href="/static/dist-tracked/front/iko-app-lite/symbol/svg/sprite.symbol.svg#dot"/>
          </svg>
      </li>
    `;
  });

  el.addClass('has-dots').append(html).find('.slider__dot').click(e => {
    this.move($(e.target).index());
  });
};

Slider.fn.calculate = function (index, el) {
  const width = $(el).outerWidth();

  this.sizes[index] = width;
  if (width > this.max) {
    this.max = width;
  }
};

Slider.fn.move = function (index) {
  const next = this.opts.arrows.find('.slider__arrows--next');
  const prev = this.opts.arrows.find('.slider__arrows--prev');

  if (index === this.items.length - 1) {
    next.hide();
  } else {
    next.show();
  }

  if (index <= 0) {
    prev.hide();
  } else {
    prev.show();
  }

  if (!this.ul.is(':animated')) {
    this.el.parent().find(`.slider__dot:eq(${index})`)
      .addClass('active')
      .siblings()
      .removeClass('active');

    this.ul.animate({
      left: `-${index}00%`,
    }, this.opts.speed, () => {
      this.current = index;
    });
  }
};

Slider.fn.next = function () {
  if (this.items.length !== this.current + 1) {
    return this.move(this.current + 1);
  }

  return undefined;
};
Slider.fn.prev = function () {
  if (this.current !== 0) {
    return this.move(this.current - 1);
  }

  return undefined;
};

Slider.fn.calculatecoord = function () {
  const height = $(this.el).height();
  const positionTop = $(this.el).offset().top;
  const navigationHeight = $('.menu').height();
  const winH = $(window).height();

  this.coord = {
    sldH: height,
    sldOffTop: positionTop,
    navHeight: navigationHeight,
    winH,
  };
};

// Slider.fn.scrollCalculate = function () {
// var winOffTop = $(window).scrollTop(),
//  pageBtmPos = winOffTop + this.coord.winH,
//  slideBtmOff = this.coord.sldOffTop + this.coord.sldH,
//  stickFromBtm, stickFromTop, inTheMiddle,
//  howMuch,
//  tempActiveSlide = activeSlide,
//  newActive,
//  slidesMax;
//
// stickFromBtm = pageBtmPos >
//  this.coord.sldOffTop && winOffTop + ( this.coord.winH - this.coord.sldH ) < this.coord.sldOffTop;
// stickFromTop = winOffTop > this.coord.sldOffTop && winOffTop < slideBtmOff;
// inTheMiddle = this.coord.sldOffTop > winOffTop && slideBtmOff < pageBtmPos;
//
// if (inTheMiddle) {
//  howMuch = 100;
// } else if (stickFromBtm) {
//  howMuch = ( ( this.coord.winH - ( this.coord.sldOffTop - winOffTop ) ) / this.coord.sldH ) * 140;
// } else if (stickFromTop) {
//  howMuch = ( ( this.coord.sldH - ( winOffTop - this.coord.sldOffTop ) ) / this.coord.sldH ) * 120;
// } else {
//  howMuch = 0;
// }
//
// slides[this.el.data('slider-number')] = howMuch;
//
// slidesMax = slides.indexOf(Math.max.apply(window, slides));
//
// newActive = slides[slidesMax] > 0 ? slidesMax : -1;

// if (newActive > 0 && newActive !== tempActiveSlide) {
//  if (slides[slidesMax] >= 80) {
//    activeSlide = newActive;
//    this.hideShowSliderArrows(tempActiveSlide, activeSlide);
//  } else {
//    this.hideSliderArrows(activeSlide);
//  }
//
// } else if (newActive === tempActiveSlide) {
//  if (slides[slidesMax] < 80) {
//    this.hideSliderArrows(activeSlide);
//  }
// } else {
//  this.hideSliderArrows(tempActiveSlide);
// }
// };

// Slider.fn.hideSliderArrows = function (slide) {
//  $('.slider-' + slide).parent().parent().find('.slider__arrows, .slider__dots').animate({
//    'opacity': 0
//  }, 200, function () {
//    $(this).hide();
//  });
//
//  activeSlide = -1;
// };
//
Slider.fn.hideShowSliderArrows = function (oldSlider, newSlider) {
  $(`.slider-${oldSlider}`).find('.slider__arrows, .slider__dots').animate({
    opacity: 0,
  }, 200, function () {
    $(this).hide();
  });

  $(`.slider-${newSlider}`)
    .parent().parent()
    .find('.slider__arrows, .slider__dots')
    .delay(200)
    .show()
    .animate({
      opacity: 1,
    }, 50, () => {
      // this.correctArrows();
    });
};

$.fn.slider = function (obj) {
  return (new Slider()).init($(this), obj);
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/plugins/slider.js